// js/password-policy.js
// Provides real-time visual feedback on password policy requirements as the
// user types. Each <li data-policy="..."> in the policy list gets .policy-met
// or .policy-unmet added on each input event.

const CHECKS = {
    'no-spaces':     function (v) { return v.length > 0 && !/\s/.test(v); },
    'min-length':    function (v) { return v.length >= 6; },
    'has-number':    function (v) { return /\d/.test(v); },
    'has-uppercase': function (v) { return /[A-Z]/.test(v); },
    'has-lowercase': function (v) { return /[a-z]/.test(v); },
    'has-symbol':    function (v) { return /[~!@$^&*\-_+|:,.?]/.test(v); },
};

/**
 * Attach real-time policy feedback to a password input and its policy list.
 *
 * @param {HTMLInputElement|null} passwordInput - The password <input> element.
 * @param {HTMLElement|null}      policyList    - The <ul> or <ol> containing
 *                                               <li data-policy="..."> items.
 */
export function initPasswordPolicy(passwordInput, policyList) {
    if (!passwordInput || !policyList) return;

    passwordInput.addEventListener('input', function () {
        const val = this.value;
        const hasTyped = val.length > 0;

        policyList.querySelectorAll('[data-policy]').forEach(function (li) {
            const key = li.dataset.policy;
            li.classList.remove('policy-met', 'policy-unmet');
            if (!hasTyped) return;
            const met = CHECKS[key] ? CHECKS[key](val) : false;
            li.classList.add(met ? 'policy-met' : 'policy-unmet');
        });
    });
}
